import { useState } from 'react'

import isServer from 'utils/isServer'

export default <Type>(initialState: Type): [Type, (value: Type) => void] => {
  const [
    value,
    _setValue,
  ] = useState<Type>(initialState)

  const setValue = (value: Type): void => {
    if (isServer) {
      return
    }

    _setValue(value)
  }

  return [
    value,
    setValue,
  ]
}
